'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { FintechOutageBannerWithFetch, ACTION_CONTEXTS } from 'account-and-billing-fintech-outages';
import { useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';

const FintechFireAlarmBanner = () => {
  useEffect(() => {
    getUsageTracker().track('bannerInteraction', {
      name: 'Fintech outage banner'
    });
  }, []);
  return /*#__PURE__*/_jsx(FintechOutageBannerWithFetch, {
    actionContext: ACTION_CONTEXTS.PURCHASE
  });
};

export default FintechFireAlarmBanner;